import React, { Component, Fragment } from 'react'
import { FormSelect } from '@myxplor/forms'
import LocalASyncStore from '../../../../local-async-store'
import Grid from '../../../../ui/grid'
import { findEnrolmentIds, findEnrolmentsInDay, dayInClaim, listOfCareHours } from './helpers'
import Week from './week'
import EducatorDisclaimer from './educator-disclaimer'
import WeekOvertime from './week-overtime'
import SelectSession, {
  validate as validateEducator,
  transformForAPI as transformSessions,
  SelectSessionsNoAllowance,
} from './select-session'
import SelectChildren, {
  validate as validateChild,
  transformForAPI as transformChild,
} from './select-children'

export const validate = values => validateEducator(values) && validateChild(values)

export const calculateSubmitValues = values => transformSessions(transformChild(values))

export const apiEndPoint = ({ govRego }) => {
  const { record_id, record_type } = govRego

  return ['/api', record_type, record_id, 'care-personnel'].join('/')
}

class CaseClaimForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayIndex: undefined,
      sessionIndex: undefined,
    }
  }

  changeEditingSession({ dayIndex, sessionIndex }) {
    this.setState({
      dayIndex,
      sessionIndex,
    })
  }

  render() {
    const {
      values = {},
      onChange,
      addKey,
      removeKey,
      issCase,
      serviceProvOptions,
      paymentTypeOptions,
      weekStart,
      educators,
    } = this.props

    const careHours = listOfCareHours(issCase, values.payment_type)

    return (
      <Fragment>
        <fieldset>
          <Grid small>
            <FormSelect
              name="service_provision"
              label="Service Provision"
              options={serviceProvOptions}
              value={values.service_provision}
              onChange={onChange}
              compact
              required
            />
            <FormSelect
              name="payment_type"
              label="Payment type"
              options={paymentTypeOptions}
              value={values.payment_type}
              onChange={onChange}
              compact
              required
            />
          </Grid>
        </fieldset>

        <WeekOvertime issCase={issCase} values={values} />

        <Week
          weekStart={weekStart}
          currentDay={this.state.dayIndex}
          render={({ day }) => {
            const claimDay = dayInClaim(issCase, values.payment_type, day)

            if (!claimDay) {
              return (
                <SelectSessionsNoAllowance
                  educators={educators.data}
                  values={values.days[day.value]}
                  nameBase={'days.' + day.value}
                  onChange={onChange}
                  addKey={addKey}
                  removeKey={removeKey}
                  curentlyEditingSession={
                    this.state.dayIndex === day.value ? this.state.sessionIndex : null
                  }
                  changeEditingSession={sessionIndex =>
                    this.changeEditingSession({ sessionIndex, dayIndex: day.value })
                  }
                  resetEditingSession={() => this.changeEditingSession({})}
                />
              )
            }

            return (
              <SelectSession
                educators={educators}
                enrolments={findEnrolmentsInDay(issCase, values.payment_type, day)}
                values={values.days[day.value]}
                nameBase={'days.' + day.value}
                onChange={onChange}
                addKey={addKey}
                removeKey={removeKey}
                hoursAvailable={careHours[day.name]}
                curentlyEditingSession={
                  this.state.dayIndex === day.value ? this.state.sessionIndex : null
                }
                changeEditingSession={sessionIndex =>
                  this.changeEditingSession({ sessionIndex, dayIndex: day.value })
                }
                resetEditingSession={() => this.changeEditingSession({})}
              />
            )
          }}
        />

        <SelectChildren records={findEnrolmentIds(issCase)} onChange={onChange} values={values} />
        <EducatorDisclaimer onChange={onChange} value={values.declaration_signed} />
      </Fragment>
    )
  }
}

export default LocalASyncStore('educators', CaseClaimForm, apiEndPoint)



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/index.jsx